import React from 'react';
import Splash_Signin from '../commons/splash_signin';
import {IndexLink, Link} from 'react-router';
var querystring = require('querystring');
import axios from 'axios';

import ReactGA from 'react-ga';
import {isMobile} from 'react-device-detect';
import Footer2Component from "../commons/footer2";

export default class EducatorsPage extends React.Component {
    constructor(props) {
        super(props);

        // Add your tracking ID created from https://analytics.google.com/analytics/web/#home/
        ReactGA.initialize('UA-122650632-1');
        // This just needs to be called once since we have no routes in this case.
        ReactGA.pageview(window.location.pathname);

        this.state = {
            first_name_lead: '',
            last_name_lead: '',
            email_name_lead: '',
            title_name_lead: '',
            part_name_lead: '',
            subscrible_name_lead: 0,
            errors: {},
            menuShow: false,
        }
    }

    mouseClick = (evt) => {
        this.setState({menuShow: !this.state.menuShow})
    }

    mouseOut = (evt) => {
        this.setState({menuShow: false})
    }

    mouseLinkClick = (link, evt) => {
        window.location = link;
    }

    render() {

		if (isMobile) {
            return (
                <div className="companies_boxx" id="v-companies_mobile">
                    <div className={"block-001 row mr0"}>
                        <Link to="/"><img className={"img_logo"} alt="mini-internships" src="/static/img/homeimg/home2/m-logo.png"/></Link>
                        <div className={"mobile-dropdown"}>
                            <svg onClick={() => this.mouseClick()} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" width="30" height="30" focusable="false">
                                <title>Menu</title>
                                <path stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeMiterlimit="10" d="M4 7h22M4 15h22M4 23h22"></path>
                            </svg>
                            <ul onMouseOut={() => this.mouseOut()} onMouseLeave={() => this.mouseOut()}  className={this.state.menuShow?"mobile-menu":"hide-el mobile-menu"}>
                                <li onClick={() => this.mouseLinkClick("/signup")}><span>Join</span></li>
                                <li onClick={() => this.mouseLinkClick("/signin")}><span>Sign in</span></li>
                            </ul>
                        </div>
                        <div className="col-xs-12 text-center t-content">
                            <h2>Add real work experiences<br/>to your courses</h2>
                            <p>Jumpstart your career with work you know you’re capable of.</p>

                            <a className="btn" href="/signup">Get Started</a>
                        </div>
                        <img className="img_logo_bg cls-image-line" src={"/static/img/homeimg/home2/img-01-line.png"}/>
                    </div>
                    <div className="row main-content how-work">
                        <span className="top-title">How it works</span>
                        <div className="s-30">&nbsp;</div>
                        <div className="div-block-10">
                            <div className="step col-xs-12 content">
                                <div className="content-center step-icon-vertical">
                                    <div className="step-line step-line-transparent step-line-vertical"></div>
                                    <div className="icon-med-wrapper">
                                        <div className="circle circle-1">&nbsp;</div>
                                    </div>
                                    <div className="step-line step-line-vertical"></div>
                                </div>
                                <div className="s-30">&nbsp;</div>
                                <div className="width-full">
                                    <span className="title">Step 1</span>
                                    <div className="content">
                                        Post a project for your business that students could complete.
                                    </div>
                                </div>
                            </div>
                            <div className="step col-xs-12 content">
                                <div className="content-center step-icon-vertical">
                                    <div className="step-line step-line-vertical"></div>
                                    <div className="icon-med-wrapper">
                                        <div className="circle circle-2">&nbsp;</div>
                                    </div>
                                    <div className="step-line step-line-vertical"></div>
                                </div>
                                <div className="s-30">&nbsp;</div>
                                <div className="width-full">
                                    <span className="title">Step 2</span>
                                    <div className="content">
                                        Students from various universities engage with your projects to prove they are a fit for your company.
                                    </div>
                                </div>
                            </div>
                            <div className="step col-xs-12 content">
                                <div className="content-center step-icon-vertical">
                                    <div className="step-line step-line-vertical"></div>
                                    <div className="icon-med-wrapper">
                                        <div className="circle circle-3">&nbsp;</div>
                                    </div>
                                    <div className="step-line step-line-vertical"></div>
                                </div>
                                <div className="s-30">&nbsp;</div>
                                <div className="width-full">
                                    <span className="title">Step 3</span>
                                    <div className="content">
                                        Use Versity’s chat and milestones feature to communicate and track progress.
                                    </div>
                                </div>
                            </div>
                            <div className="step col-xs-12 content">
                                <div className="content-center step-icon-vertical">
                                    <div className="step-line step-line-vertical"></div>
                                    <div className="icon-med-wrapper">
                                        <div className="circle circle-4">&nbsp;</div>
                                    </div>
                                    <div className="step-line step-line-transparent step-line-vertical"></div>
                                </div>
                                <div className="s-30">&nbsp;</div>
                                <div className="width-full">
                                    <span className="title">Step 4</span>
                                    <div className="content">
                                        Receive students’ work and provide feedback for student portfolios.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="s-100 s-40">&nbsp;</div>
                    <div className="row main-content logos-wrapper">
                        <div className="logos">
                            <div className="logo logo-1">&nbsp;</div>
                            <div className="logo logo-2">&nbsp;</div>
                            <div className="logo logo-3">&nbsp;</div>
                            <div className="logo logo-4">&nbsp;</div>
                        </div>
                    </div>
                    <div className="s-60 s-40">&nbsp;</div>
                    <div className="row main-content wrapper-testimonies">
                        <div className="testimonies">
                            <div className="mask w-slider-mask" id="w-slider-mask-0">
                                <div className="slider-testimony-box w-slide" aria-label="2 of 3" role="group">
                                    <div className="testimony-wrapper">
                                        <div className="testimony-text">
                                            <img src="/static/img/homeimg/companies/img-quote.png" alt="" className="image-8"/>
                                            <div className="s-20 _w-30">&nbsp;</div>
                                            <p className="p-regular text-left">I really love how easy Versity is to use. Why have one summer internship when you can have several and get experience, faster? </p>
                                        </div>
                                        <div className="_w-30 s-30">&nbsp;</div>
                                        <div className="testimony-person width-full">
                                            <div className="student-avatar avatar-square company-logo logo-company-2">&nbsp;</div>
                                            <div className="s-20">&nbsp;</div>
                                            <div className="testimony-name">
                                                <div className="h5-medium dark-gray">Brianna Giselle</div>
                                                <div className="p-regular "><em>University of Central Florida</em></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="s-100 s-40">&nbsp;</div>
                    <div className="row main-content wrapper-benefits">
                        <div className="benefits">
                            <div className="perks-wrapper">
                                <div className="s-10">&nbsp;</div>
                                <div className="perk-item">
                                    <div className="glyphicon glyphicon-ok icon-check"></div>
                                    <div className="_w-10">&nbsp;</div>
                                    <div className="h5-light">Jumpstart Your Career</div>
                                </div>
                                <div className="s-10">&nbsp;</div>
                                <div className="perk-item">
                                    <div className="glyphicon glyphicon-ok icon-check"></div>
                                    <div className="_w-10">&nbsp;</div>
                                    <div className="h5-light">Get Paid For Your Work</div>
                                </div>
                            </div>
                            <div className="perks-wrapper">
                                <div className="s-10">&nbsp;</div>
                                <div className="perk-item">
                                    <div className="glyphicon glyphicon-ok icon-check"></div>
                                    <div className="_w-10">&nbsp;</div>
                                    <div className="h5-light">Land Your Dream Job</div>
                                </div>
                                <div className="s-10">&nbsp;</div>
                                <div className="perk-item">
                                    <div className="glyphicon glyphicon-ok icon-check"></div>
                                    <div className="_w-10">&nbsp;</div>
                                    <div className="h5-light">Enhance Your Skill Set</div>
                                </div>
                            </div>
                            <div className="w-layout-grid grid-11">&nbsp;</div>
                        </div>
                    </div>
                    <div className="logos-wrapper-new press-logos">
                        <div className="logos logos-news">
                            <div className="logo logo-press-1">&nbsp;</div>
                            <div className="logo logo-press-2">&nbsp;</div>
                            <div className="logo logo-press-3">&nbsp;</div>
                        </div>
                    </div>
                    <div className="row any-question mr0">
                        <div className="main-content">
                            <span className="top-title">Any questions? We are here to help</span>
                            <div className="div-block-101">
                                <div className="row pd0">
                                    <div className="col-xs-12 content">
                                        <span className="title">What projects can be done on Versity?</span>
                                        <div className="content">
                                            Anything you can do on a computer can be done through Versity.
                                        </div>
                                    </div>
                                    <div className="col-xs-12 content">
                                        <span className="title">How does Versity make money?</span>
                                        <div className="content">
                                            Versity charges students a 20% transaction fee to cover the costs of our operations.
                                        </div>
                                    </div>
                                </div>
                                <div className="row pd0">
                                    <div className="col-xs-12 content">
                                        <span className="title">I just got paid on the website, but don’t see anything in my bank account.  Where’s my money?</span>
                                        <div className="content">
                                            Payouts on our platform take 2-5 days and show up directly in your bank account. Generally the first time you get paid it takes 5 business days for it to appear.
                                        </div>
                                    </div>
                                    <div className="col-xs-12 content">
                                        <span className="title">I’m a grad student, is Versity for me?</span>
                                        <div className="content">
                                            Yes! We are open to any student with .edu address (including grad students!)
                                        </div>
                                    </div>
                                </div>
                                <div className="t-footer">
                                    <div className="content">
                                        <a className="btn" href="/signup">Get Started</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer2Component isSlash={true}/>
                </div>
            )
        }

        return (
            <div id="splash" className="v-home">
                <header>
                    <div className="header">
                        <div className="splash_logo"><Link to="/"><img alt="VERSITY" src="/static/img/appimg/top_login_h_logo.png"/></Link></div>
                        <Splash_Signin type="0" openDialog={this.props.openDialog} url="/code/apis.php"/>
                    </div>
                </header>
                <div id="v-companies" className="splash_wrapper companies_boxx">
                    <div className="splash-block row pd0">
                        <div className="row tops">
                            <div className="t-header">
                                <div className="content">
                                    <h1 className="title">Add real work experiences to your courses</h1>
                                    <span className="sub-title">Jumpstart your career with work you know you’re capable of.</span>
                                </div>
                            </div>
                            <div className="t-footer">
                                <div className="content">
                                    <a className="btn" href="/signup">Get Started</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row main-content how-work">
                        <span className="top-title">How it works</span>
                        <div className="s-30">&nbsp;</div>
                        <div className="div-block-10">
                            <div className="to-do-left col-xs-3 content pd0">
                                <div className="content-center step-icon-vertical">
                                    <div className="step-line step-line-transparent step-line-vertical"></div>
                                    <div className="icon-med-wrapper">
                                        <div className="circle circle-1">&nbsp;</div>
                                    </div>
                                    <div className="step-line step-line-vertical"></div>
                                </div>
                                <div className="s-30">&nbsp;</div>
                                <span className="title">Step 1</span>
                                <div className="content">
                                    Post a project for your business that students could complete.
                                </div>
                            </div>
                            <div className="to-do-middle col-xs-3 content pd0">
                                <div className="content-center step-icon-vertical">
                                    <div className="step-line step-line-vertical"></div>
                                    <div className="icon-med-wrapper">
                                        <div className="circle circle-2">&nbsp;</div>
                                    </div>
                                    <div className="step-line step-line-vertical"></div>
                                </div>
                                <div className="s-30">&nbsp;</div>
                                <span className="title">Step 2</span>
                                <div className="content">
                                    Students from various universities engage with your projects to prove they are a fit for your company.
                                </div>
                            </div>
                            <div className="to-do-right col-xs-3 content pd0">
                                <div className="content-center step-icon-vertical">
                                    <div className="step-line step-line-vertical"></div>
                                    <div className="icon-med-wrapper">
                                        <div className="circle circle-3">&nbsp;</div>
                                    </div>
                                    <div className="step-line step-line-vertical"></div>
                                </div>
                                <div className="s-30">&nbsp;</div>
                                <span className="title">Step 3</span>
                                <div className="content">
                                    Use Versity’s chat and milestones feature to communicate and track progress.
                                </div>
                            </div>
                            <div className="to-do-right col-xs-3 content pd0">
                                <div className="content-center step-icon-vertical">
                                    <div className="step-line step-line-vertical"></div>
                                    <div className="icon-med-wrapper">
                                        <div className="circle circle-4">&nbsp;</div>
                                    </div>
                                    <div className="step-line step-line-transparent step-line-vertical"></div>
                                </div>
                                <div className="s-30">&nbsp;</div>
                                <span className="title">Step 4</span>
                                <div className="content">
                                    Receive students’ work and provide feedback for student portfolios.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="s-100 s-40">&nbsp;</div>
                    <div className="row main-content logos-wrapper">
                        <div className="logos">
                            <div className="logo logo-1">&nbsp;</div>
                            <div className="logo logo-2">&nbsp;</div>
                            <div className="logo logo-3">&nbsp;</div>
                            <div className="logo logo-4">&nbsp;</div>
                            <div className="logo logo-5">&nbsp;</div>
                            <div className="logo logo-6">&nbsp;</div>
                            <div className="logo logo-7">&nbsp;</div>
                        </div>
                    </div>
                    <div className="s-60 s-40">&nbsp;</div>
                    <div className="row main-content wrapper-testimonies">
                        <div className="testimonies">
                            <div className="mask w-slider-mask" id="w-slider-mask-0">
                                <div className="slider-testimony-box w-slide" aria-label="2 of 3" role="group">
                                <div className="testimony-wrapper">
                                    <div className="testimony-person width-full">
                                        <div className="student-avatar avatar-square company-logo logo-company-2">&nbsp;</div>
                                        <div className="s-20">&nbsp;</div>
                                        <div className="testimony-name">
                                            <div className="h5-medium dark-gray">Brianna Giselle</div>
                                            <div className="p-regular "><em>University of Central Florida</em></div>
                                        </div>
                                    </div>
                                    <div className="_w-30 s-30">&nbsp;</div>
                                    <div className="testimony-text">
                                        <img src="/static/img/homeimg/companies/img-quote.png" alt="" className="image-8"/>
                                        <div className="s-20 _w-30">&nbsp;</div>
                                        <p className="p-regular text-left">I really love how easy Versity is to use. Why have one summer internship when you can have several and get experience, faster? </p>
                                    </div>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                    <div className="s-60 s-40">&nbsp;</div>
                    <div className="row main-content wrapper-benefits">
                        <div className="benefits">
                            <div className="perks-wrapper">
                                <div className="s-10">&nbsp;</div>
                                <div className="perk-item">
                                    <div className="glyphicon glyphicon-ok icon-check"></div>
                                    <div className="_w-10">&nbsp;</div>
                                    <div className="h5-light">Jumpstart Your Career</div>
                                </div>
                                <div className="s-10">&nbsp;</div>
                                <div className="perk-item">
                                    <div className="glyphicon glyphicon-ok icon-check"></div>
                                    <div className="_w-10">&nbsp;</div>
                                    <div className="h5-light">Get Paid For Your Work</div>
                                </div>
                            </div>
                            <div className="perks-wrapper">
                                <div className="s-10">&nbsp;</div>
                                <div className="perk-item">
                                    <div className="glyphicon glyphicon-ok icon-check"></div>
                                    <div className="_w-10">&nbsp;</div>
                                    <div className="h5-light">Land Your Dream Job</div>
                                </div>
                                <div className="s-10">&nbsp;</div>
                                <div className="perk-item">
                                    <div className="glyphicon glyphicon-ok icon-check"></div>
                                    <div className="_w-10">&nbsp;</div>
                                    <div className="h5-light">Enhance Your Skill Set</div>
                                </div>
                            </div>
                            <div className="w-layout-grid grid-11">&nbsp;</div>
                        </div>
                    </div>
                    <div className="s-100 s-40">&nbsp;</div>
                    <div className="logos-wrapper-new press-logos">
                        <div className="logos logos-news">
                            <div className="logo logo-press-1">&nbsp;</div>
                            <div className="logo logo-press-2">&nbsp;</div>
                            <div className="logo logo-press-3">&nbsp;</div>
                            <div className="logo logo-press-4">&nbsp;</div>
                        </div>
                    </div>
                    <div className="row any-question">
                        <div className="s-60 s-40">&nbsp;</div>
                        <div className="main-content">
                            <span className="top-title">Any questions? We are here to help</span>
                            <div className="s-30">&nbsp;</div>
                            <div className="div-block-101">
                                <div className="row">
                                    <div className="col-xs-6 content">
                                        <span className="title">What projects can be done on Versity?</span>
                                        <div className="content">
                                            Anything you can do on a computer can be done through Versity.
                                        </div>
                                    </div>
                                    <div className="col-xs-6 content">
                                        <span className="title">How does Versity make money?</span>
                                        <div className="content">
                                            Versity charges students a 20% transaction fee to cover the costs of our operations.
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-xs-6 content">
                                        <span className="title">I just got paid on the website, but don’t see anything in my bank account.  Where’s my money?</span>
                                        <div className="content">
                                            Payouts on our platform take 2-5 days and show up directly in your bank account. Generally the first time you get paid it takes 5 business days for it to appear.
                                        </div>
                                    </div>
                                    <div className="col-xs-6 content">
                                        <span className="title">I’m a grad student, is Versity for me?</span>
                                        <div className="content">
                                            Yes! We are open to any student with .edu address (including grad students!)
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="s-60 s-40">&nbsp;</div>
                    </div>
                </div>
                <Footer2Component isSlash={true}/>
            </div>
        )
    }
}



/** WEBPACK FOOTER **
 ** ./src/client/app/homecomponents/pages/educators.js
 **/